import React from "react";

const RechargeProcess = () => {
  return (
    <section id="bc-agents" className="py-5 bg-light">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <span className="hero-badge bg-gold bg-opacity-10">
              <i className="fas fa-users me-2"></i> Join Our Network
            </span>
            <h2 className="display-5 fw-bold mt-3">Become a BC Agent</h2>
            <p className="lead text-muted">
              Empower your community with banking services and earn attractive
              commissions. Simple onboarding, 24/7 support, and cutting-edge
              technology.
            </p>
          </div>
        </div>

        {/* 3-Step Process */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="step-process-wrapper">
              <div className="row g-4 justify-content-center">
                <div className="col-md-4">
                  <div className="step-card text-center p-4 bg-white rounded-4 shadow-sm h-100">
                    <div className="step-number">1</div>
                    <div className="step-icon mb-3">
                      <i className="fas fa-user-plus fa-2x text-gold"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Register Now</h5>
                    <p className="text-muted small mb-0">
                      Register with your basic details, mobile number, and
                      email. We provide full support to help you get started
                      smoothly.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card text-center p-4 bg-white rounded-4 shadow-sm h-100">
                    <div className="step-number">2</div>
                    <div className="step-icon mb-3">
                      <i className="fas fa-store fa-2x text-gold"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Complete KYC Verification</h5>
                    <p className="text-muted small mb-0">
                      Submit your KYC documents and shop proof, and our team
                      will handle the verification process, including an outlet
                      visit.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card text-center p-4 bg-white rounded-4 shadow-sm h-100">
                    <div className="step-number">3</div>
                    <div className="step-icon mb-3">
                      <i className="fas fa-certificate fa-2x text-gold"></i>
                    </div>
                    <h5 className="fw-bold mb-2">
                      Start Earning as a Certified BC Agent
                    </h5>
                    <p className="text-muted small mb-0">
                      Get certified as an authorized BC Agent, receive your
                      credentials and dashboard access, and start earning
                      earning instantly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Verification Details Card */}
        <div className="row mb-5 justify-content-center">
          <div className="col-md-10">
            <div
              className="verification-card p-4 rounded-4"
              style={{
                background: "linear-gradient(135deg, #0A2540, #1A3A5F)",
                color: "white",
              }}
            >
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h5 className="fw-bold mb-2">
                    <i
                      className="fas fa-shield-alt me-2"
                      style={{ color: "#D4AF37" }}
                    ></i>
                    Physical & Shop Verification Required
                  </h5>
                  <p className="mb-0 small opacity-75">
                    As a bank-licensed Corporate Business Correspondent, we
                    conduct thorough physical verification of the agent and shop
                    premises to ensure compliance and security for all
                    stakeholders.
                  </p>
                </div>
                <div className="col-md-4 text-md-end mt-3 mt-md-0">
                  <span
                    className="badge px-3 py-2"
                    style={{ background: "#D4AF37", color: "#0A2540" }}
                  >
                    <i className="fas fa-check-circle me-1"></i> RBI Compliant
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Row */}
        <div className="row g-4 mb-5">
          <div className="col-md-4">
            <div className="text-center p-4 bg-white rounded-4 shadow-sm h-100">
              <i className="fas fa-file-alt fa-3x text-gold mb-3"></i>
              <h5>Simple Documentation</h5>
              <p className="text-muted">
                PAN, Aadhaar, Bank Account, and Shop proof required for
                verification.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center p-4 bg-white rounded-4 shadow-sm h-100">
              <i className="fas fa-chart-line fa-3x text-gold mb-3"></i>
              <h5>High Commissions</h5>
              <p className="text-muted">
                Industry-best payout structures on AEPS, DMT, CMS & UPI Cash
                Point.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="text-center p-4 bg-white rounded-4 shadow-sm h-100">
              <i className="fas fa-headset fa-3x text-gold mb-3"></i>
              <h5>Dedicated Support</h5>
              <p className="text-muted">
                Technical & operational support to ensure smooth daily
                transactions.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-3">
          <a href="/contact-us" className="btn btn-gold btn-lg">
            <i className="fas fa-handshake me-2"></i> Apply for BC Agent
          </a>
        </div>
      </div>

      <style>{`
    .step-card {
      position: relative;
      transition: all 0.3s ease;
      border: 1px solid rgba(0,0,0,0.05);
    }
    .step-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 30px -12px rgba(0,0,0,0.1);
      border-color: rgba(212, 175, 55, 0.3);
    }
    .step-number {
      position: absolute;
      top: -15px;
      left: 20px;
      width: 35px;
      height: 35px;
      background: linear-gradient(135deg, #D4AF37, #B8960F);
      color: #0A2540;
      font-weight: bold;
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-shadow: 0 4px 10px rgba(212,175,55,0.3);
    }
    .step-icon i {
      color: #D4AF37;
    }
    .verification-card {
      border: 1px solid rgba(212, 175, 55, 0.3);
      box-shadow: 0 10px 25px -12px rgba(0,0,0,0.2);
    }
    @media (max-width: 768px) {
      .step-number {
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        width: 30px;
        height: 30px;
        font-size: 0.9rem;
      }
      .step-card {
        padding-top: 1.5rem;
      }
    }
  `}</style>
    </section>
  );
};

export default RechargeProcess;
